// Desglose del MRR de mensuales del mes en curso a partir de `GET /subscriptions/stripe-stats`.
// Lo comparten la card "MRR" (`SubscriptionsKpis`) y la barra del mes actual (`ForecastChart`).
//
// Criterio: las bajas programadas (`canceledMonthly`) son dinero que no se cuenta, aunque sigan
// dentro de `monthlyBilling` hasta el cierre de su periodo. Se restan desde el principio para
// que el MRR base no vaya bajando a lo largo del mes según se aplican: cuando una baja se hace
// efectiva sale a la vez de `monthlyBilling` y de `canceledMonthly`, y el base no se mueve.
//
// - base    = monthlyBilling - nuevo MRR del mes - bajas programadas de subs anteriores al mes
// - newMrr  = nuevo MRR del mes, sin las altas del mes que ya tienen baja programada
// - current = base + newMrr  (= monthlyBilling - todas las bajas programadas)
//
// Las altas del mes con baja programada se descuentan del nuevo MRR (no del base), cruzando por
// `id`; si no se restaran de ahí, se contarían dos veces contra el base.
export function mrrBreakdown(stats) {
  const monthlyBilling = Number(stats?.monthlyBilling) || 0;
  const newItems = stats?.newMonthlySubscriptionsThisMonth?.items || [];
  const newMrrGross = Number(stats?.newMonthlySubscriptionsThisMonth?.mrrAddedEUR) || 0;
  const newIds = new Set(newItems.map((it) => it?.id).filter(Boolean));

  let lostOld = 0;
  let lostNew = 0;
  (stats?.canceledMonthly || []).forEach((c) => {
    const amount = Number(c?.cycleAmountEUR) || 0;
    if (c?.id && newIds.has(c.id)) lostNew += amount;
    else lostOld += amount;
  });

  const base = Math.max(monthlyBilling - newMrrGross - lostOld, 0);
  const newMrr = Math.max(newMrrGross - lostNew, 0);

  return {
    base,
    newMrr,
    current: base + newMrr,
    lostMrr: lostOld + lostNew,
  };
}
